import { INFO_COLOR_FOOTER } from "../../../../Data/Bonus Ui/BasicCard";
import CommonCard from "../Common/CommonCard";

const InfoColorFooter = () => {
  return (
    <>
      {INFO_COLOR_FOOTER.map((item, index) => (
        <CommonCard key={index} data={item} />
      ))}
    </>
  )
}

export default InfoColorFooter